import React from 'react';

export default function Footer() {
    return (
        <footer
            className="flex items-center justify-between px-6 py-2.5 text-[11px] font-medium transition-colors duration-200"
            style={{
                background: 'var(--color-sidebar, #FFFFFF)',
                borderTop: '1px solid var(--color-border, #E2E8F0)',
                color: 'var(--color-subtext, #64748B)',
                flexShrink: 0,
            }}
        >
            <div className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
                <span>© {new Date().getFullYear()} VocalForLocal WOMS</span>
            </div>
            <div className="font-mono text-[10px] text-slate-400">
                v2.0 • Enterprise Edition
            </div>
        </footer>
    );
}
